import React, {useEffect} from 'react';
import View from './PointsCardView';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {dobroruDataSelector} from '../../../redux/selectors/dobroru';
import {profileHolderVolunteerIdSelector} from '../../../redux/selectors/profile';
import {getDobroruData} from '../../../redux/actions/dobroru';

export const PointsCard = () => {
  const dispatch = useAppDispatch();
  const volunteerId = useSelector(profileHolderVolunteerIdSelector);
  useEffect(() => {
    if (volunteerId) dispatch(getDobroruData());
  }, [volunteerId]);

  const data = useSelector(dobroruDataSelector);

  return <View score={data?.actualScores || 0} />;
};
